export default __webpack_public_path__ + "static/media/trusted-2.e714723e.webp";